import { render, staticRenderFns } from "./AdminLake.vue?vue&type=template&id=778003ca&"
import script from "./AdminLake.vue?vue&type=script&lang=js&"
export * from "./AdminLake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports